module.exports = __webpack_public_path__ + "static/media/north_south_paleoamerica_icon_small.c48c277d.png";